import React, { useEffect, useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { useForm } from "react-hook-form";
import { addEmailTemplate, updateEmailTemplate, getEmailTemplateById, downloadEmailTemplateAttachment, addEmailTemplateAttachment, deleteEmailTemplateAttachment } from '../../services/EmailTemplateService';
import { useDropzone } from 'react-dropzone';
import { InboxOutlined } from '@ant-design/icons';
import Globals from '../../config/globals';
import { toast, confirm } from '@rickylandino/react-messages';
import ReactLoading from 'react-loading';
import { List, message, Spin, Radio, Space } from 'antd';

function MyDropzone(props) {
    const maxSize = 1048576;

    const onDrop = useCallback(acceptedFiles => {
        const reader = new FileReader()
        let file = acceptedFiles[0];

        reader.onload = async function () {
            props.setFile(file);
            //setValue("templateName", templateName);

            //setState({
            //    ...state
            //});
            //props.addFile(file);
        }
        reader.readAsArrayBuffer(file);
    }, [])

    const { isDragActive, getRootProps, getInputProps, isDragReject, rejectedFiles } = useDropzone({
        onDrop,
        minSize: 0,
        accept: 'text/html, text/htm, text/plain'
    });

    const isFileTooLarge = rejectedFiles?.length > 0 && rejectedFiles[0].size > maxSize;

    return (
        <div className="ant-upload ant-upload-drag">
            <div {...getRootProps()} className="pt-4 h-100">
                <input {...getInputProps()} />
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                {!isDragActive && 'Click here to select an html or txt attachment'}
                {isDragActive && !isDragReject && "Drop the file!"}
                {isDragReject && "File type not accepted, sorry!"}
                {isFileTooLarge && (
                    <div className="text-danger mt-2">
                        File is too large.
                    </div>
                )}
            </div>
        </div>
    );
}

function MyAttachmentDropzone(props) {
    const maxSize = 1048576;

    const onDrop = useCallback(acceptedFiles => {
        const reader = new FileReader()
        let file = acceptedFiles[0];

        reader.onload = async function () {
            props.setFile(file);
            //props.addFile(file);

        }
        reader.readAsArrayBuffer(file);
    }, [])

    const { isDragActive, getRootProps, getInputProps, isDragReject, rejectedFiles } = useDropzone({
        onDrop,
        minSize: 0,
        accept: 'application/pdf'
    });

    const isFileTooLarge = rejectedFiles?.length > 0 && rejectedFiles[0].size > maxSize;

    return (
        <div className="ant-upload ant-upload-drag">
            <div {...getRootProps()} className="pt-4 h-100">
                <input {...getInputProps()} />
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                {!isDragActive && 'Click here to select an attachment (PDF format)'}
                {isDragActive && !isDragReject && "Drop the file!"}
                {isDragReject && "File type not accepted, sorry!"}
                {isFileTooLarge && (
                    <div className="text-danger mt-2">
                        File is too large.
                    </div>
                )}
            </div>
        </div>
    );
}

export default function EmailTemplatePane(props) {
    const [state, setState] = useState({
        paneTitle: '',
        templateType: '',
        emailTemplate: {},
        templateEditMode: '',
        showFileUpload: true,
        showClearFile: false,
        dataLoaded: false
    });

    const [showPane, setShowPane] = useState(true);
    const [file, setFile] = useState({});
    const [documentTypes, setDocumentTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, setValue, getValues } = useForm();
    const theme = window.sessionStorage.getItem("theme");
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    const [templateAttachments, setTemplateAttachments] = useState([]);

    useEffect(() => {
        var showFileUpload;
        var showClearFile;

        setState({
            ...state,
            dataLoaded: false
        });

        if (props.templateEditMode === 'Edit') {
            getEmailTemplateById(props.emailTemplate.emailTemplates_ID).then(data => {
                if (data.template) {
                    console.log(data.template);
                    setValue("template", props.emailTemplate);
                    setValue("templateName", props.emailTemplate.templateName);
                    setValue("templateType", props.emailTemplate.templateType);
                    setValue("emailSubject", props.emailTemplate.emailSubject);
                    setValue("templateData", data.template.templateData);
                    setValue("selectedApp", data.template.app);

                    setTemplateAttachments(data.templateAttachments);

                    //showFileUpload = false;
                    //showClearFile = true;
                } else {
                    toast.error("Something went wrong");
                }
                //setDataLoaded(true);

            }).catch(error => {
                toast.error("Something went wrong");
            });

            //setValue("templateName", props.emailTemplate.templateName);
            //setValue("templateType", props.emailTemplate.templateType);
            //setValue("notes", props.emailTemplate.notes);

            if (props.emailTemplate.templateData === null) {
                showFileUpload = true;
                showClearFile = false;
            }
            else {
                showFileUpload = false;
                showClearFile = true;
            }
        }
        else {
            setValue("templateName", "");
            setValue("templateType", "");
            setValue("emailSubject", "");
            setValue("templateData", null);
            setValue("selectedApp", "");
            showFileUpload = true;
            showClearFile = false;
        }

        setState({
            ...state,
            paneTitle: props.paneTitle,
            templateType: props.templateType,
            emailTemplate: props.emailTemplate,
            templateEditMode: props.templateEditMode,
            showFileUpload,
            showClearFile,
            dataLoaded: true
        });

    }, [props]);

    function hidePane() {
        setShowPane(false);

        setTimeout(() => {
            props.hidePane();
        }, 1000)
    }

    function screenDataOK() {
        let errString = '';

        if (!getValues("templateType")) {
            errString += 'Email Type must be specified<br />';
        }
        if (!getValues("selectedApp")) {
            errString += 'An App must be selected<br />';
        }

        if (errString !== '') {
            var htmlErrorContent = <div dangerouslySetInnerHTML={{ __html: errString }} />

            toast.error(htmlErrorContent);
            return false;
        }
        else {
            return true;
        }
    }

    function handleSave() {
        if (screenDataOK() === false) {
            return;
        }

        setLoading(true);

        let formdata = new FormData();
        if (state.templateEditMode === 'Edit') { formdata.append('templateID', props.emailTemplate.emailTemplates_ID); }
        if (file?.name === undefined) {
/*            console.log(getValues().templateData);*/
            formdata.append('templateData', getValues().templateData);
            formdata.append('newFile', null);
        }
        else {
/*            console.log(file);*/
            formdata.append('newFile', file);
            formdata.append('templateData', null);
        }
        
        formdata.append('templateName', getValues().templateName);
        formdata.append('templateType', getValues().templateType);
        formdata.append('emailSubject', getValues().emailSubject);
        formdata.append('uploadedBy', userInfo.userName);
        formdata.append('app', getValues().selectedApp);

        if (state.templateEditMode === 'Add') {
            addEmailTemplate(formdata).then(data => {
                toast.success("Email template successfully added!");
                hidePane();
                props.updateEmailTemplateInfo(data);
            });
        }
        else {
            updateEmailTemplate(formdata).then(data => {
                toast.success("Email template successfully updated!");
                hidePane();
                props.updateEmailTemplateInfo(data);
            });
        }
    }

    function handleFile(file) {
        setFile(file);

        let templateName = file?.name;
        setValue("templateName", templateName);

        setState({
            ...state
        });
    }

    function handleClearFile() {
        setValue("templateName", "");

        setState({
            ...state,
            showFileUpload: true,
            showClearFile: false
        });
    }

    function handleDownloadTemplateAttachment(record) {
        let postdata = {
            id: record.emailTemplateAttachments_ID.toString()
        }

        const key = "downloadattachment";

        message.loading({
            content: 'Downloading Attachment...',
            key,
            duration: 0,
            style: {
                position: "fixed",
                bottom: 0,
                left: 0
            },
        });

        downloadEmailTemplateAttachment(postdata).then(data => {
            message.destroy(key);

            const url = window.URL.createObjectURL(new Blob([data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = record.fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(error => {
            toast.error("Something went wrong");
            console.log(error);
        })
    }

    function handleUploadNewFile(newlyUploadedFile) {
        const key = "uploadattachment";

        message.loading({
            content: 'Uploading Attachment...',
            key,
            duration: 0,
            style: {
                position: "fixed",
                bottom: 0,
                left: 0
            },
        });

        let formdata = new FormData();
        formdata.append('attachmentData', newlyUploadedFile);
        formdata.append('emailTemplates_ID', props.emailTemplate.emailTemplates_ID);

        addEmailTemplateAttachment(formdata).then(data => {
            message.destroy(key);
            setTemplateAttachments(data);
        });
    }

    function handleDeleteTemplateAttachment(record) {
        confirm({
            title: "You are about to permanently delete this attachment",
            content: "Are you sure you would like to proceed?",
            buttons: ["Yes", "No"]
        }, (buttonPressed) => {
            if (buttonPressed === 'Yes') {
                let formdata = new FormData();
                formdata.append('emailTemplateAttachments_ID', record.emailTemplateAttachments_ID);
                formdata.append('emailTemplates_ID', getValues().template.emailTemplates_ID);

                deleteEmailTemplateAttachment(formdata).then(data => {
                    toast.success("Email template attachment successfully deleted!");
                    setTemplateAttachments(data);
                });

                return 0;
            } else {
                return 0;
            }
        });
    }

    function handleSelectedAppChange(e) {
        setState({
            ...state,
            selectedApp: e.target.value
        });
    }

    return (
        <SlidingPane
            overlayClassName='pinkCard'
            className={'smallPane'}
            isOpen={showPane || false}
            title={state.templateEditMode === 'Add' ? 'Add New Email Template' : 'Update Email Template'}
            onRequestClose={hidePane}
            shouldCloseOnEsc={false}
            closeIcon={<i className="fas fa-chevron-right float-left"></i>}
        >
            <Spin spinning={!state.dataLoaded}>
                <div className="slide-pane-body">
                    <div style={state.showFileUpload === true ? {} : { display: 'none' }}>
                        <MyDropzone setFile={(file) => handleFile(file)} />
                    </div>
                    {/*Selected HTML File:&nbsp;{file?.name && <pre className="mb-4">{file.name}</pre>}*/}

                    <form>
                        <div className="row">
                            <div className="form-group col-12">
                                <label className="form-label">Selected File:&nbsp;</label><br />
                                <label className="form-label" style={{ color: "green" }}>{getValues().templateName}</label>&nbsp;&nbsp;&nbsp;
                                <button type="button" class="btn btn-link" onClick={handleClearFile} style={state.showClearFile === true ? {} : { display: 'none' }}>Clear File</button>
                                {/*<input {...register("templateName", { required: true })} className="form-control-custom" disabled={true} />*/}
                            </div>

                            <div className="form-group col-12">
                                <label className="form-label">Email Type</label>
                                <input {...register("templateType", { required: true })} className="form-control-custom" disabled={state.templateEditMode === 'Edit' ? true : false} />
                            </div>
                            <div className="form-group col-12">
                                <label className="form-label">Email Subject</label>
                                <textarea {...register("emailSubject")} className="form-control-custom" />
                            </div>

                            <div>
                                <label className="form-label">Select App:</label>&nbsp;&nbsp;
                                <input type="radio" value="WEBCM" {...register("selectedApp")} className="mt-1" />&nbsp;<label className="form-label">WEBCM</label>&nbsp;&nbsp;&nbsp;
                                <input type="radio" value="MSO" {...register("selectedApp")} className="mt-1" />&nbsp;<label className="form-label">MyShowOnline</label>&nbsp;&nbsp;&nbsp;
                            </div>
                        </div>
                    </form>
                    {state.templateEditMode !== 'Add' &&
                        <div className="text-start">
                            <hr />

                            <label className="form-label">Upload a new attachment</label>
                            <div className="mb-3">
                                <MyAttachmentDropzone setFile={handleUploadNewFile} />
                            </div>
                            <List
                                size="small"
                                header={<div>Uploaded Attachments</div>}
                                bordered
                                dataSource={templateAttachments}
                                renderItem={(item, idx) =>
                                    <List.Item
                                        actions={[
                                            <button type="button" id="downloadAttachment" onClick={() => { handleDownloadTemplateAttachment(item) }} className="btn btn-link">Download</button>,
                                            <button type="button" id="deleteAttachment" onClick={() => { handleDeleteTemplateAttachment(item) }} className="btn btn-link">Delete</button>
                                        ]}
                                    >
                                        <List.Item.Meta
                                            title={<span>{item.fileName}</span>}
                                        />
                                        {/*<div>{Moment(item.uploadedDate).format("L")}</div>*/}
                                    </List.Item>
                                }
                            />
                        </div>
                    }
                </div>
            </Spin>

            <div className="modal-footer">
                <div className="form-group col-12 padding-25-10">
                    <button className="btn btn-submit" onClick={handleSave} disabled={loading}>{loading ? <ReactLoading className='tableLoading float-left' type={"spokes"} color={'#F30079'} height={30} width={30} /> : 'Set Template'}</button>
                    <button className="btn btn-outline-primary ms-3 float-right" onClick={hidePane}>Cancel</button>
                </div>
            </div>
        </SlidingPane>
    );
}